import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=a39b31d6&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src566367325/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a39b31d6')) {
      api.createRecord('a39b31d6', component.options)
    } else {
      api.reload('a39b31d6', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=a39b31d6&", function () {
      api.rerender('a39b31d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Email.vue"
export default component.exports